import { Grid, GridItem } from '@consta/uikit/Grid'
import { Text } from '@consta/uikit/Text'
import { For } from '@library/components'
import type { FC, ReactNode } from 'react'

import type { ButtonItem } from './constants'
import css from './CreateTab.css'

type ButtonBlockProps = {
  title: string
  tabs: ButtonItem[]
  children: (tab: ButtonItem) => ReactNode
}

export const ButtonBlock: FC<ButtonBlockProps> = ({ children, tabs, title }) => {
  return (
    <div className={css.block}>
      <Text size="m" view="secondary">
        {title}
      </Text>
      <Grid cols={2} gap="s">
        <For each={tabs}>
          {tab => {
            return <GridItem key={tab.type}>{children(tab)}</GridItem>
          }}
        </For>
      </Grid>
    </div>
  )
}
